export default "__VITE_ASSET__f807c260__"